export default {
  primary: "#0025b0",
  galaxy: ["#f1078e", "#c4ff0f", "#0722ef"],
};
